import React, { useEffect } from "react";
import {
    AppBar,
    makeStyles,
    Tab,
    Tabs,
} from "@material-ui/core";
import { useStatsTab } from "../../viewmodel/hooks/getCurrentTab";
import { useTranslation } from "react-i18next";
import Rankings from "../pages/Rankings";
import Awards from "../pages/Awards";
import { getRanks } from "../../viewmodel/providers/ranks";

const useStyles = makeStyles((theme) => ({
    tab: {
        marginBottom: "4em",
        marginTop: "20px",
        borderRadius: "10px",
        borderStyle: "solid",
        borderColor: theme.palette.primary.main,
        overflow: "hidden",
    },
    tabStyle: {
        fontSize: 18,
        ["@media (min-width: 780px)"]: {
            fontSize: 20,
        },
    },
    defaultTabStyle: {
        color: theme.palette.primary.main,
        backgroundColor: "white",
        opacity: 1,
    },
    activeTabStyle: {
        color: "white",
        backgroundColor: theme.palette.primary.main,
    },
    removeLowerLine: {
        display: "none",
    },
}));

type TabPanelProps = {
    children: React.ReactChild | React.ReactFragment | React.ReactPortal | boolean;
    value: number,
    index: number,
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `nav-tab-${index}`,
        "aria-controls": `nav-tabpanel-${index}`,
    };
}

export default function StatsTab(): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();
    const [state, setTabState, setRank] = useStatsTab();

    useEffect(() => {
        getRanks(setRank);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTabState(newValue);
    };
    return (
        <div>
            <AppBar position="static" classes={{ root: classes.tab }}>
                <Tabs
                    variant="fullWidth"
                    value={state.value}
                    onChange={handleChange}
                    classes={{ indicator: classes.removeLowerLine }}
                >
                    <Tab
                        label={t("stats.ranking")}
                        className={`${state.value === 0 ? classes.activeTabStyle : classes.defaultTabStyle} ${classes.tabStyle}`}
                        {...a11yProps(0)}
                    />
                    <Tab
                        label={t("stats.awards")}
                        className={`${state.value === 1 ? classes.activeTabStyle : classes.defaultTabStyle} ${classes.tabStyle}`}
                        {...a11yProps(1)}
                    />
                </Tabs>
            </AppBar>
            <TabPanel value={state.value} index={0}>
                <Rankings rank={state.rank} thisWeekBestRank={state.thisWeekBestRank} allTimeBestRank={state.allTimeBestRank} />
            </TabPanel>
            <TabPanel value={state.value} index={1}>
                <Awards />
            </TabPanel>
        </div>
    );
}
